import { Box, Grid, IconButton, Theme, Tooltip, Typography, useTheme } from '@mui/material'
import React from 'react'
import { InfoIconOutlined } from '../../../assets/SvgIcons'

interface Labels {
    title: string
}
type Props = {
    data: Array<Labels>
}

export default function PerformanceTooltip(props: Props): JSX.Element {
    const { data } = props
    const theme = useTheme()

    const mapColorIndex: { [key: number]: string } = {
        0: theme.palette.primary[500] ?? "#1e90ff",
        1: theme.palette.warning[500] ?? "#f79009",
        2: theme.palette.success[800] ?? "#065536",
        3: theme.palette.customColors.brightCerulean,
        4: theme.palette.error[800] ?? "#852538"
    }


    return (
        <Tooltip
            slotProps={{
                tooltip: {
                    sx: {
                        margin: "0px !important",
                        backgroundColor: theme.palette.customColors.cinder,
                        borderRadius: '15px'
                    }
                }
            }}
            title={
                <Box
                    sx={{
                        borderRadius: '10px',
                        padding: '15px',
                    }}
                >
                    {data?.map((obj, index) => {
                        return (
                            <Grid key={index} container alignItems="center" columnSpacing={2} mb={(index !== data?.length - 1) ? 1 : 0} flexWrap="nowrap" >
                                <Grid item xs="auto">
                                    <Box
                                        sx={{
                                            borderRadius: '50%',
                                            backgroundColor: mapColorIndex[index],
                                            width: '10px',
                                            height: '10px'
                                        }}
                                    />
                                </Grid>
                                <Grid item>
                                    <Typography
                                        variant='subtitle_500'
                                        color='common.white'
                                    >
                                        {obj?.title ?? ""}
                                    </Typography>
                                </Grid>
                            </Grid>
                        )
                    })}
                </Box >
            }
        >
            <IconButton aria-label="More Information">
                <InfoIconOutlined />
            </IconButton>
        </Tooltip >
    )
}